/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_shoe_lining = /** @type {(inputs: {}) => string} */ () => {
	return `Podšívka boty`
};

const da_attributes_shoe_lining = /** @type {(inputs: {}) => string} */ () => {
	return `Skoforing`
};

const de_attributes_shoe_lining = /** @type {(inputs: {}) => string} */ () => {
	return `Schuhfutter`
};

const en_attributes_shoe_lining = /** @type {(inputs: {}) => string} */ () => {
	return `Shoe Lining`
};

const es_attributes_shoe_lining = /** @type {(inputs: {}) => string} */ () => {
	return `Forro del zapato`
};

const fr_attributes_shoe_lining = /** @type {(inputs: {}) => string} */ () => {
	return `Doublure de chaussure`
};

const hu_attributes_shoe_lining = /** @type {(inputs: {}) => string} */ () => {
	return `Cipő Bélés`
};

const it_attributes_shoe_lining = /** @type {(inputs: {}) => string} */ () => {
	return `Fodera della scarpa`
};

const nl_attributes_shoe_lining = /** @type {(inputs: {}) => string} */ () => {
	return `Schoenvoering`
};

const pl_attributes_shoe_lining = /** @type {(inputs: {}) => string} */ () => {
	return `Wyściółka buta`
};

const pt_attributes_shoe_lining = /** @type {(inputs: {}) => string} */ () => {
	return `Forro do sapato`
};

const sv_attributes_shoe_lining = /** @type {(inputs: {}) => string} */ () => {
	return `Skofoder`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_shoe_lining = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_shoe_lining(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_shoe_lining", locale)
	if (locale === "cs") return cs_attributes_shoe_lining(inputs)
	if (locale === "da") return da_attributes_shoe_lining(inputs)
	if (locale === "de") return de_attributes_shoe_lining(inputs)
	if (locale === "en") return en_attributes_shoe_lining(inputs)
	if (locale === "es") return es_attributes_shoe_lining(inputs)
	if (locale === "fr") return fr_attributes_shoe_lining(inputs)
	if (locale === "hu") return hu_attributes_shoe_lining(inputs)
	if (locale === "it") return it_attributes_shoe_lining(inputs)
	if (locale === "nl") return nl_attributes_shoe_lining(inputs)
	if (locale === "pl") return pl_attributes_shoe_lining(inputs)
	if (locale === "pt") return pt_attributes_shoe_lining(inputs)
	return sv_attributes_shoe_lining(inputs)
};
export { attributes_shoe_lining as "attributes.shoe_lining" }